import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IKnmExpertType } from '../interfaces/IKnmExpertType';

export async function fetchErknmKnmExpertTypes(): Promise<IKnmExpertType[]> {
  return apiGet<IKnmExpertType[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/erknm/knm-expert-types`);
}
